import React, { useState } from "react";
import "../../assets/css/ngodashboard/NGOMasterLayout.css";
import Ngosidebar from "../ngodashboard/Ngosidebar";
import NgoTopBar from "../ngodashboard/NgoTopBar";

const NGOMasterLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="receiver-master-layout">
        {/* Sidebar */}
        <div
          className={`receiver-sidebar-wrapper ${sidebarOpen ? "open" : ""}`}
        >
          <Ngosidebar />
        </div>

        {/* Main Content Area */}
        <div className="receiver-main-content">
          {/* Top Bar */}
          <NgoTopBar onMenuToggle={toggleSidebar} userName="Fatima Ali" />

          {/* Page Content */}
          <div className="receiver-content-area">{children}</div>
        </div>

        {/* Mobile Overlay */}
        {sidebarOpen && (
          <div
            className="receiver-sidebar-overlay"
            onClick={toggleSidebar}
          ></div>
        )}
      
    </div>
  );
};

export default NGOMasterLayout;
